/**
 * @type {URLSearchParams}
 */
const searchParams = currentUrl.searchParams;

/**
 * @returns {number|undefined}
 */
export const getUid = () =>
	searchParams.has('uid') ? parseInt(searchParams.get('uid')) : undefined;

/**
 * @returns {string|undefined}
 */
export const getSessionToken = () =>
	searchParams.has('sessionToken')
		? searchParams.get('sessionToken')
		: undefined;

export default searchParams;
